import * as React from 'react';

const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="58"
    fill="none"
    viewBox="0 0 58 58"
  >
    <path
      fill="#F04438"
      d="M29 .875C13.475.875.875 13.475.875 29S13.475 57.125 29 57.125 57.125 44.525 57.125 29 44.525.875 29 .875zm0 45a3.761 3.761 0 01-3.75-3.75 3.761 3.761 0 013.75-3.75 3.761 3.761 0 013.75 3.75 3.761 3.761 0 01-3.75 3.75zm4.294-29.081L32.038 31.83A3.044 3.044 0 0129 34.625a3.044 3.044 0 01-3.038-2.794l-1.256-15.037A4.306 4.306 0 0129 12.125c2.4 0 4.313 1.95 4.313 4.313 0 .112 0 .243-.02.356z"
    ></path>
  </svg>
);

export { WarningIcon };
